<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>
<script setup lang="ts">
import { onMounted, watch } from 'vue';
import { useAuthStore } from '@/store';
import { useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { APP_NAME } from '@/constants';

const router = useRouter();
const authStore = useAuthStore();
const { isLogin } = storeToRefs(authStore);

onMounted(() => {
  document.title = APP_NAME ?? '';
});

watch(isLogin, (newValue) => {
  if (!newValue) {
    router.push('/auth');
  } else {
    router.push('/');
  }
});
</script>
